@if (isHydraEmployed) {
  <form [formGroup]="form">
    <div class="dropdown-header text-center">
      {{ 'portal.backendSystem' | portalTranslate }}
    </div>
    <ng-select
      class=""
      id="targetSystem"
      [clearable]="false"
      [items]="targetSystems"
      [loading]="form.controls.targetSystem.disabled"
      [searchable]="false"
      (change)="onValueChange()"
      bindLabel="label"
      bindValue="value"
      formControlName="targetSystem"
    >
    </ng-select>
  </form>
}
